import * as api from '../api/adapters/json_api';

// The periods a recurring template was run for (FIN-1266): read only, except
// for confirming every waiting invoice of a period at once.
const type = 'api_resources/recurring_periods';

export default {
  forTemplate: (templateId) => api.read({ type }, {
    query: { filter: { template_id: templateId }, page: { size: 100, number: 1 } },
  }),

  show: (id) => api.read({ type, id }, {}),

  confirmInvoices: (id) => api.create({ type, id, action: 'confirm_invoices' }, {}, {}),
};
